<template>
	<wt-selector :options="options" v-model="Value" :clearable="true"></wt-selector>
</template>
<script>
export default {
  name: 'lab-product-selector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      this.$store.dispatch('getPrimaryOrganization').then(data => {
        this.options = [{
          label:data.name,
          value:data.id
        }]
        if (this.options.length === 1) {
          this.Value = this.options[0].value
        }
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
